<template>
  <b-overlay 
    variant="dark"
  >
    <b-card no-body>
      <b-card-header>
        Download opmerkingen
      </b-card-header>
      <b-card-body>
        <b-form-row>
          <b-col>
            <b-form-group label="Relatie">
              <relatie-select 
                v-model="excel.relatie"
                @input="getTelling"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Installateur">
              <b-select
                v-model="excel.installateur"
                :options="installateurs"
                text-field="Naam"
                value-field="Id"
                @change="getTelling"
              >
                <template #first>
                  <option 
                    value="null" 
                  >
                    -- Kies een onderhoudsfirma --
                  </option>
                </template>
              </b-select>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group 
              label="Soorten" 
              description="Kies voor opmerkingen bij acties en/of gebreken"
            >
              <b-check-group 
                v-model="excel.typen" 
                :options="['Acties','Gebreken']"
                disabled
              />
            </b-form-group>
          </b-col>
        </b-form-row>
      </b-card-body>

      <b-card-footer>
        <b-card-text 
          v-if="telling > -1" 
          class="pull-right"
        >
          {{ telling }} opmerkingen
        </b-card-text><br><br>
        <b-button 
          size="lg" 
          variant="success"
          class="pull-right"
          @click="downloadExcel"
        >
          <b-spinner 
            v-if="busy"
            small
          /> <i 
            v-else 
            class="fa fa-table"
          /> Download Excel
        </b-button>
      </b-card-footer>
    </b-card>
  </b-overlay>
</template>
<script>
import { saveAs } from "file-saver";
import { serviceMixin } from "@/mixins/serviceMixin";
import RelatieSelect from './RelatieSelect.vue'
export default {
    name: 'DownloadOpmerkingen',
    components: {RelatieSelect},
    mixins: [serviceMixin,],
    props: {
    },
    data() {
        return  {
            telling: -1,
            excel : {
                typen: ['Acties','Gebreken'],
                installateur: null,
                relatie: null
            },
            downloadnaam: 'opmerkingen.xlsx',
            busy: false,
            installateurs: [],
        }
    },
    computed: {
    criteria: function() {
        return {
          onderhoudsfirma: this.excel.installateur == null ? null : this.excel.installateur.toString(),
          relatie: this.excel.relatie == null ? null : this.excel.relatie.id.toString()
        }
        
      }
    },
    mounted () {
        this.getOnderhoudsfirmas();
    },
    methods: {
       getTelling() {
        var vm = this;
        this.telling = -1;
        vm.busy = true;
        this.post(`/opmerkingen/telling`, this.criteria)
          .then(function (response) {
            console.dir(response.data);
            vm.telling = response.data.aantal;
          })
          .catch(function (error) {
            console.log(error);
          }).finally(function () {
            vm.busy = false;
          });
      },
        getOnderhoudsfirmas() {
      var vm = this;
      this.get("/onderhoud/relaties")
        .then(function (response) {
          console.dir(response.data);
          vm.installateurs = response.data.relaties;
        })
        .catch(function (error) {
          console.log(error);
        });
      },
      downloadExcel() {
      var vm = this;
      this.busy = true;
      this.$http
        .post(
          "/opmerkingen",
          this.criteria,
          { responseType: "arraybuffer" }
        )
        .then((response) => {
          console.log(response.data);
          var blob = new Blob([response.data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, vm.downloadNaam);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(function () {
          vm.busy = false;
        });
      }
    },
          
}
</script>